// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".msg-error{color:#b64351;line-height:12px;font-size:12px;padding:0 12px;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
